<template>
  <div class="container-page">
    <p class="title-inner">Журнал аудита</p>
    <TabsListInner>
      <TabsDetailInner name="Учет операций в системе" selected>
        <AuditLogActions />
      </TabsDetailInner>
      <TabsDetailInner name="Учет посещаемости страниц" :selected="false">
        <AuditLogVisits />
      </TabsDetailInner>
    </TabsListInner>
  </div>
</template>

<script>
  import TabsDetailInner from '@/common/components/TabsDetailInner.vue';
  import TabsListInner from '@/common/components/TabsListInner.vue';

  import AuditLogActions from '@/modules/admin/components/AuditLogActions.vue';
  import AuditLogVisits from '@/modules/admin/components/AuditLogVisits.vue';

  export default {
    name: 'AuditLog',
    components: { AuditLogActions, AuditLogVisits, TabsListInner, TabsDetailInner },
  };
</script>
